import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { TokenService } from '../service/token.service';
import { PoModalComponent, PoPopupAction } from '@po-ui/ng-components';
import { AuthService } from '../service/auth.service';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import { FilterComponent } from '../filter/filter.component';

@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.css'],
})
export class WelcomeComponent implements OnInit {
  @Output() filter = new EventEmitter();
  @Output() typePage = new EventEmitter();
  @Output() logStatus = new EventEmitter();
  @Input() errorBoards: any = [];
  @ViewChild(PoModalComponent, { static: true }) poModal!: PoModalComponent;
  @ViewChild(FilterComponent, { static: false }) appFilter!: FilterComponent;
  @ViewChild('refreshButton', { static: false }) refreshButton!: ElementRef;

  serviceRastreamento: boolean = false;
  newSalutation!: string;
  myTenant!: any;
  routerMoment!: any;
  displayFilter: boolean = true;
  exibeDownload: boolean = false;
  blob!: any;
  imagePath: string = './assets/imgs/logo-totvs-white-new.png';
  actions: Array<PoPopupAction> = [];
  actionsConfigs: Array<PoPopupAction> = [];
  routerName!: any;
  moduleVisible: boolean = false;
  filterStateRefresh!: any;
  public refreshButtonDisabled = true;
  splitRouterInformation!: any;

  constructor(
    private el: ElementRef,
    private router: Router,
    private tokenService: TokenService
  ) {
    this.routerMoment = this.router;
    this.getActionsToolbar();
    this.getConfigsToolbar();
  }

  ngOnInit() {
    let objectComponentsAccess: any = localStorage.getItem('componentsAccess');
    let splitComponentsAccess: any = objectComponentsAccess?.split(',');
    splitComponentsAccess.length > 1
    ? this.moduleVisible = true
    : this.moduleVisible = false;

    let splitRouter = this.routerMoment.url;
    let splitRouterBar = splitRouter.split('/');
    let splitRouterInformationInit = splitRouterBar[1].split('?');
    this.splitRouterInformation = splitRouterBar[2];
    splitRouterInformationInit[0] == 'selling-products' || splitRouterInformationInit[0] == 'sales-group' || splitRouterInformationInit[0] == 'sales-filial'  || splitRouterInformationInit[0] == 'sales-sallers' || splitRouterInformationInit[0] == 'pedding-conditionals' || splitRouterInformationInit[0]== 'sales-record-detail'
      ? (this.toggleFilters(), (this.routerName = splitRouterInformationInit[0]))
      : (this.routerName = '');
    
    this.myTenant = this.tokenService.getTenant()?.toString();
    this.salutationFunction();
  }

  async getActionsToolbar() {
    this.myTenant = this.tokenService.getTenant()?.toString();
    let arrayAction = [
      {
        icon: 'po-icon-company',
        label: this.myTenant,
      },
      {
        icon: 'po-icon-user',
        label: localStorage.getItem('username'),
      },
      {
        label: 'Sair',
        icon: 'po-icon-exit',
        type: 'danger',
        action: () => this.logout(),
      },
    ];
    this.actions = arrayAction;
  }

  openDocument() {
    if (this.splitRouterInformation == 'sale') {
      window.open(
        'https://tdn.totvs.com/pages/releaseview.action?pageId=766947764',
        '_blank'
      );
    }
    if (this.splitRouterInformation == 'salers') {
      window.open(
        'https://tdn.totvs.com/pages/viewpage.action?pageId=880448700',
        '_blank'
      );
    } 
    if (this.splitRouterInformation == 'financial') {
      window.open(
        'https://tdn.totvs.com/pages/releaseview.action?pageId=787856724',
        '_blank'
      );
    } 
    if (this.splitRouterInformation == 'manufacturing') {
      window.open(
        'https://tdn.totvs.com/x/9VjDLw',
        '_blank'
      );
    }
  }

  async getConfigsToolbar() {
    let arrayAction = [
      {
        icon: 'po-icon-target',
        label: 'Log',
        action: () => this.toggleLog(),
      },
      {
        icon: 'po-icon-document-filled',
        label: 'Documento',
        action: () =>
          this.openDocument(),
      },
      {
        icon: 'po-icon-print',
        label: 'Imprimir',
        action: () => window.print(),
      },
      {
        icon: 'po-icon-xml',
        label: '.xlsx',
        action: () => this.excelPrint(),
      },
    ];
    this.actionsConfigs = arrayAction;
  }

  excelPrint() {
    const EXCEL_TYPE =
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const EXCEL_EXTENSION = '.xlsx';

    let dataExcelHourlySales = [];
    let dataPaymentMethods = [];
    let dataRankingSellers = [];
    let dataBillingValue = [];
    let dataBillingDay = [];
    let dataTopSelling = [];
    let dataInformative = [];
    let dataRankingFilial = [];
    let dataSellingProducts = [];

    let objectHourlySales = localStorage.getItem('hourly-sales');
    let objectPaymentMethods = localStorage.getItem('payment-methods');
    let objectBillingValue = localStorage.getItem('billing-value');
    let objectBillingDay = localStorage.getItem('billing-day');
    let objectTopSelling = localStorage.getItem('top-selling');
    let objectInformative = localStorage.getItem('informative');
    let objectRankingFilial = localStorage.getItem('ranking-filial');
    let objectRankingSellers = localStorage.getItem('ranking-sellers');
    let objectSellingProducts = localStorage.getItem('selling-products');

    objectHourlySales != null
      ? (dataExcelHourlySales = JSON.parse(objectHourlySales))
      : (dataExcelHourlySales = []);
    const worksheetHourlySales = XLSX.utils.json_to_sheet(dataExcelHourlySales);
    objectPaymentMethods != null
      ? (dataPaymentMethods = JSON.parse(objectPaymentMethods))
      : (dataPaymentMethods = []);
    const worksheetPaymentMethods =
      XLSX.utils.json_to_sheet(dataPaymentMethods);
    objectBillingValue != null
      ? (dataBillingValue = JSON.parse(objectBillingValue))
      : (dataBillingValue = []);
    const worksheetBillingValue = XLSX.utils.json_to_sheet(dataBillingValue);
    objectBillingDay != null
      ? (dataBillingDay = JSON.parse(objectBillingDay))
      : (dataBillingDay = []);
    const worksheetBillingDay = XLSX.utils.json_to_sheet(dataBillingDay);
    objectTopSelling != null
      ? (dataTopSelling = JSON.parse(objectTopSelling))
      : (dataTopSelling = []);
    const worksheetTopSelling = XLSX.utils.json_to_sheet(dataTopSelling);
    objectInformative != null
      ? (dataInformative = JSON.parse(objectInformative))
      : (dataInformative = []);
    const worksheetInformative = XLSX.utils.json_to_sheet(dataInformative);
    objectRankingFilial != null
      ? (dataRankingFilial = JSON.parse(objectRankingFilial))
      : (dataRankingFilial = []);
    const worksheetRankingFilial = XLSX.utils.json_to_sheet(dataRankingFilial);
    objectRankingSellers != null
      ? (dataRankingSellers = JSON.parse(objectRankingSellers))
      : (dataRankingSellers = []);
    const worksheetRankingSellers =
      XLSX.utils.json_to_sheet(dataRankingSellers);
    objectSellingProducts != null
      ? (dataSellingProducts = JSON.parse(objectSellingProducts))
      : (dataSellingProducts = []);
    const worksheetSellingProducts= XLSX.utils.json_to_sheet(dataSellingProducts);

    const workbook = {
      Sheets: {
        informativo: worksheetInformative,
        'vendas-por-hora': worksheetHourlySales,
        'formas-pagamento': worksheetPaymentMethods,
        'ranking-vendedores': worksheetRankingSellers,
        'valor-medio-faturado-dia': worksheetBillingValue,
        'percentual-medio-faturado-dia': worksheetBillingDay,
        'top-10-mais-vendidos': worksheetTopSelling,
        'produtos-mais-vendidos': worksheetSellingProducts,
        'ranking-loja': worksheetRankingFilial,
      },
      SheetNames: [
        'informativo',
        'vendas-por-hora',
        'formas-pagamento',
        'ranking-vendedores',
        'valor-medio-faturado-dia',
        'percentual-medio-faturado-dia',
        'top-10-mais-vendidos',
        'produtos-mais-vendidos',
        'ranking-loja',
      ],
    };
    const excelBuffer: any = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'buffer',
    });
    const data: Blob = new Blob([excelBuffer], {
      type: EXCEL_TYPE,
    });
    FileSaver.saveAs(data, 'minhas-operacoes-info' + EXCEL_EXTENSION);
  }

  goModulos() {
    this.router.navigate(['/modulo']);
  }

  filterChange(item: any) {
    this.filter.emit(item);
    this.toggleFilters();
    this.filterStateRefresh = item;
    this.validateFilterManufacturingShow(this.filterStateRefresh);
  }

  refreshFilter() {
    this.refreshButtonDisabled = false;

    if (this.routerMoment.url !== '/home/sale') {
      this.appFilter.onFilter();
    } else {
      this.appFilter.onFilterRefresh();
    }

    let filterDontVisible = this.el.nativeElement.querySelector('.show-filter');
    if (filterDontVisible) {
      filterDontVisible.classList.add('dont-show-filter');
      filterDontVisible.classList.remove('show-filter');
    }

    setTimeout(() => {
    this.refreshButtonDisabled = true;
  }, 1000);
  }

  addServiceRastreamento() {
    this.serviceRastreamento
      ? (this.exibeDownload = true)
      : (this.exibeDownload = false);
    this.logStatus.emit();
  }

  saveFile() {
    let stringErrorFull = 'Sem informação de rastreio de log ' + new Date();
    if (this.errorBoards.length != 0 && this.exibeDownload) {
      stringErrorFull = '';
      this.errorBoards.map((el: any) => {
        stringErrorFull = stringErrorFull + el;
      });
    }
    this.blob = new Blob([stringErrorFull], {
      type: 'text/plain;charset=utf-8',
    });
    saveAs(this.blob, 'arquivo-log.txt');
  }


  getCurrentPathname(): string {
    return this.router.url;
  }

  toggleFilterAuthorization(){
    const raw = localStorage.getItem('sellerCode');
    return raw ? JSON.parse(raw) : null;
  }

  getCurrentSellerAuthorization (): boolean {
    const pathname = this.getCurrentPathname();
    return pathname === '/home/salers' &&  this.toggleFilterAuthorization() ? true:false
  }


  toggleFilters() {
    let filterVisible =
      this.el.nativeElement.querySelector('.dont-show-filter');
    let filterDontVisible = this.el.nativeElement.querySelector('.show-filter');
    if(this.getCurrentSellerAuthorization()){
      filterDontVisible.classList.remove('show-filter');
      this.displayFilter = true
    }else{
      this.displayFilter = false
      if (filterVisible) {
        filterVisible.classList.add('show-filter');
        filterVisible.classList.remove('dont-show-filter');
      }
      if (filterDontVisible) {
        filterDontVisible.classList.add('dont-show-filter');
        filterDontVisible.classList.remove('show-filter');
      }
    }


  }

  toggleLog() {
    let logVisible = this.el.nativeElement.querySelector('.dont-show-log');
    let logDontVisible = this.el.nativeElement.querySelector('.show-log');
    if (logVisible) {
      logVisible.classList.add('show-log');
      logVisible.classList.remove('dont-show-log');
    }
    if (logDontVisible) {
      logDontVisible.classList.add('dont-show-log');
      logDontVisible.classList.remove('show-log');
    }
  }

  logout() {
    this.tokenService.signOut();
  }

  // Função responsável por gerar a mensagem de boas vindas
  salutationFunction() {
    let salutationGood = new Array();
    salutationGood[0] = 'Bom dia';
    salutationGood[1] = 'Boa tarde';
    salutationGood[2] = 'Boa noite';

    let week = new Array();
    week[0] = 'Domingo';
    week[1] = 'Segunda-Feira';
    week[2] = 'Terça-Feira';
    week[3] = 'Quarta-Feira';
    week[4] = 'Quinta-Feira';
    week[5] = 'Sexta-Feira';
    week[6] = 'Sábado';

    let monthSmall = new Array();
    monthSmall[0] = 'de janeiro';
    monthSmall[1] = 'de fevereiro';
    monthSmall[2] = 'de março';
    monthSmall[3] = 'de abril';
    monthSmall[4] = 'de maio';
    monthSmall[5] = 'de junho';
    monthSmall[6] = 'de julho';
    monthSmall[7] = 'de agosto';
    monthSmall[8] = 'de setembro';
    monthSmall[9] = 'de outubro';
    monthSmall[10] = 'de novembro';
    monthSmall[11] = 'de dezembro';

    let dateObj = new Date();
    let month = monthSmall[dateObj.getUTCMonth()];
    let day = dateObj.getUTCDate();
    let dayWeek = week[dateObj.getDay()];

    let salutation = 'Bom dia';
    let hour = dateObj.getHours();
    if (hour < 5) {
      salutation = salutationGood[2];
    } else if (hour < 12) {
      salutation = salutationGood[0];
    } else if (hour < 18) {
      salutation = salutationGood[1];
    } else {
      salutation = salutationGood[2];
    }

    this.newSalutation =
      dayWeek + ', ' + day + ' ' + month + ' - ' + salutation;
  }

  validateFilterManufacturingShow(item: any) {
    if (
      this.routerMoment.url === '/home/manufacturing' &&
      item.branch.length > 0 &&
      item.dataMin !== null &&
      item.dataMax !== null &&
      (item.typeClassification.length > 0 && item.typeClassification[0] !== undefined) &&
      item.typeClassificationLocation !== null
    ) {
      let filterDontVisible =
        this.el.nativeElement.querySelector('.show-filter');
      if (filterDontVisible) {
        filterDontVisible.classList.add('dont-show-filter');
        filterDontVisible.classList.remove('show-filter');
      }
    }
  }
}
